import { render } from "./TeamShow.vue?vue&type=template&id=c75ea800&scoped=true"
import script from "./TeamShow.vue?vue&type=script&lang=js"
export * from "./TeamShow.vue?vue&type=script&lang=js"

import "./TeamShow.vue?vue&type=style&index=0&id=c75ea800&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75ea800"]])

export default __exports__